<script lang="ts" setup>
import { replaceURLsWithLinks } from "~/utils/typography";

export interface EventInfoDescription {
  description: string;
}

const { t } = useI18n();
const props = defineProps<EventInfoDescription>();

const eventTextDescriptionExpanded = ref(false);
const descriptionElement = ref<HTMLElement | null>(null);

const eventDescription = computed(() => {
  const description = replaceURLsWithLinks(props.description);

  const newLineSymIndex = description?.indexOf("\n");

  if (eventTextDescriptionExpanded.value || newLineSymIndex === -1)
    return description;

  return `${description?.substring(0, newLineSymIndex)}...`;
});
const isDescriptionOverflowing = computed(() => {
  if (!descriptionElement.value)
    return;
  const isOverFlowing = descriptionElement?.value?.scrollHeight > descriptionElement?.value?.clientHeight
    || (eventDescription.value?.length ?? 0) < (props.description?.length ?? 0);
  return isOverFlowing;
});
const toggleTextDescriptionExpanded = () => eventTextDescriptionExpanded.value = !eventTextDescriptionExpanded.value;
</script>

<template>
  <div class="mt-4 flex">
    <div ref="descriptionElement" class="text-secondary whitespace-pre-wrap text-sm break-all" :class="{ 'line-clamp-1': !eventTextDescriptionExpanded }">
      <span v-html="eventDescription" />

      <BaseButton
        v-if="eventTextDescriptionExpanded"
        link
        type="secondary"
        class="text-sm underline mx-1"
        :name="t('labels.less')"
        @click="toggleTextDescriptionExpanded"
      >
        {{ t('labels.less') }}
      </BaseButton>
    </div>
    <BaseButton
      v-if="!eventTextDescriptionExpanded && isDescriptionOverflowing"
      link
      type="secondary"
      class="text-sm underline"
      :name="t('labels.more')"
      @click="toggleTextDescriptionExpanded"
    >
      {{ t('labels.more') }}
    </BaseButton>
  </div>
</template>
